import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "play-mario-block"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mario-msg-overlay" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "-purple" }, "You found all the coins!", -1)
const _hoisted_5 = { class: "blocks" }

import SuperMario from "@/components/SuperMario/SuperMario.vue";
import SceneSection from "@/components/Common/SceneSection.vue";
import Block from "@/components/SuperMario/Block.vue";
import useIntersectionObserver from "@/hooks/useIntersectionObserver";
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useGsap } from "@/hooks/useGsap";
import { random } from "@/helpers/random";


export default /*#__PURE__*/_defineComponent({
  __name: 'SuperMarioScene',
  emits: ["jumped", "foundCoin"],
  setup(__props) {



const { observeElement } = useIntersectionObserver;
const gsap = useGsap();
const marioState = ref<string | null>(null);
const isMarioPlay = ref(false);
const randomNumber = ref(1);
const foundCoins = ref(0);
const coinsToBeFound = ref(6);
const observer = ref<IntersectionObserver>();
const optionsOfObserver = ref({
  threshold: 0.8,
  rootMargin: "10px",
});
const audioMarioStart = new Audio("/smw_princess_help.ogg");
const audioPowerUp = new Audio("/smw_power-up.ogg");
const audioExit = new Audio("/smw_keyhole_exit.ogg");

// checks if coins reach the limit
const hasFoundAllCoins = computed(() => {
  return foundCoins.value === coinsToBeFound.value;
});

function createRandomNumber() {
  randomNumber.value = random(1, 3);
}

function onFoundCoin() {
  createRandomNumber();
  !hasFoundAllCoins.value && foundCoins.value++;

  if (hasFoundAllCoins.value) {
    audioPowerUp.play();
    onOpenMessage();
  }

  if (foundCoins.value === 1) {
    document.body.classList.remove("is-playing-mario");
    document.body.classList.add("has-played-mario");
  }
}

function onMarioPlay() {
  audioMarioStart.play();
  isMarioPlay.value = true;
  document.body.classList.remove("is-mario-viewport");
  document.body.classList.add("is-playing-mario");
}

function onJumped(block: HTMLElement) {
  const rect = block.getBoundingClientRect();
  const blockCenter = Math.floor(rect.x + rect.width / 2);
  const blockBottom = rect.bottom;

  jumpMario(blockCenter, blockBottom);
}

function jumpMario(blockCenter: number, blockBottom: number) {
  const mario = document.querySelector(".mario");

  if (!mario) {
    return;
  }

  const marioRect = mario.getBoundingClientRect();
  const isJumpingLeft = marioRect.x > blockCenter;
  const marioFloor = window.innerHeight - marioRect.height;
  const marioAnimation = gsap.timeline();

  marioAnimation
    .clear(true)
    .set(mario, {
      rotationY: isJumpingLeft ? 180 : 0,
    })
    .fromTo(
      mario,
      0.3,
      {
        left: marioRect.x,
        top: marioFloor,
      },
      {
        onStart: () => {
          marioState.value = "up";
        },
        motionPath: [
          {
            left: blockCenter - marioRect.width / 2,
            top: window.innerWidth <= 1024 ? blockBottom * 0.85 : blockBottom,
          },
          {
            left: isJumpingLeft ? blockCenter - 128 : blockCenter + 128,
            top: window.innerWidth <= 1024 ? marioFloor * 0.9 : marioFloor,
          },
        ],
        ease: "steps(5)",
        onComplete: () => {
          marioState.value = hasFoundAllCoins.value ? "celebrate" : null;
        },
      }
    );
}

function onOpenMessage() {
  audioExit.play();
  const timeline = gsap.timeline();
  timeline
    .to("#Mario .mario-msg", 1, {
      scale: 1,
      ease: "steps(12)",
    })
    .to(
      "#Mario .mario-msg .later",
      0.1,
      {
        autoAlpha: 1,
      },
      "+=2"
    );
}
function onCloseMessage() {
  const timeline = gsap.timeline();
  timeline.to("#Mario .mario-msg, #Mario .mario-msg-overlay", 1, {
    scale: 0,
    ease: "steps(12)",
  });
}

function intersectCallback(entry: IntersectionObserverEntry) {
  if (entry.isIntersecting) {
    // when mario scene is in viewport
    // block scrolling
    !isMarioPlay.value && document.body.classList.add("is-mario-viewport");

    // if mario has played
    // show game
    isMarioPlay.value && document.body.classList.add("has-played-mario");
  }

  if (!entry.isIntersecting) {
    // if leave from mario game
    document.body.classList.remove("has-played-mario");
  }
}

onMounted(() => {
  // create observer for mario scene
  const marioScene = document.getElementById("Mario");
  if (marioScene) {
    observer.value = observeElement(
      marioScene,
      intersectCallback,
      optionsOfObserver.value
    );
  }
  createRandomNumber();
});
onBeforeUnmount(() => {
  // disconnect from observer after changing route
  observer.value?.disconnect();
  document.body.classList.remove(
    "has-played-mario",
    "is-mario-viewport",
    "is-playing-mario"
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SceneSection, {
    id: "Mario",
    "aria-labelledby": "marioDesc"
  }, _createSlots({
    default: _withCtx(() => [
      (!isMarioPlay.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              onClick: onMarioPlay,
              class: "play-mario-button"
            }, "Play Game")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (isMarioPlay.value)
      ? {
          name: "container",
          fn: _withCtx(() => [
            _withDirectives(_createElementVNode("div", { class: "mario-coin-counter" }, _toDisplayString(foundCoins.value), 513), [
              [_vShow, foundCoins.value]
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _hoisted_2,
              _createElementVNode("div", { class: "mario-msg" }, [
                _createTextVNode(" Thanks for jumping so many times. "),
                _hoisted_3,
                _hoisted_4,
                _createElementVNode("div", { class: "later" }, [
                  _createTextVNode(" ;) "),
                  _createElementVNode("button", {
                    class: "mario-msg-close",
                    type: "button",
                    title: "Close message",
                    onClick: onCloseMessage
                  }, " ✕ ")
                ])
              ])
            ], 512), [
              [_vShow, _unref(hasFoundAllCoins)]
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (block, i) => {
                return _createVNode(Block, {
                  key: i,
                  "has-coin": randomNumber.value === i + 1,
                  "has-found-all-coins": _unref(hasFoundAllCoins),
                  onJumped: onJumped,
                  onFoundCoin: onFoundCoin
                }, null, 8, ["has-coin", "has-found-all-coins"])
              }), 64))
            ]),
            _createVNode(SuperMario, { state: marioState.value }, null, 8, ["state"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}
}

})